import DeleteMemberModal from './DeleteMemberModal.vue';

export default DeleteMemberModal;
